jQuery(document).ready(function($) {

  if ($('.woocommerce-message').length > 0) {
    setTimeout(function () {
      //$('.woocommerce-message').remove()
    }, 5000)
  }

  $('h1, .about .close').on('click', function() {
    if ($('body').hasClass('home')) {
      $('.carousel-container').toggleClass('carousel-container--about-open')
      $('body').toggleClass('about--is-showing')
      $('.carousel-cell').removeClass('showing-description')
      $('.pane').removeClass('caption--is-showing')
      $('body').removeClass('carousel-description--is-showing')
      $('html, body').animate({ scrollTop: 0 }, 1)
    }
  })

  $('.controls .zoom, .zoom-container .close').on('click', function() {
    var $pane = $(this).closest('.pane')
    var $image = null
    if ($pane.find('.flipped').length > 0) {
      $image = $pane.find('.back')
    } else {
      $image = $pane.find('.front')
    }
    var largeZoomImage = $image.data('zoom-large-url')
    $('.zoom-container').toggleClass('zoom-container--is-showing')
    if ($('.zoom-container').hasClass('zoom-container--is-showing')) {
      $('.zoom-container .photo img').eq(0).attr('src', '/wp-content/themes/samplesale/assets/img/1x1.png')
      $('.zoom-container .photo img').eq(0).attr('src', largeZoomImage)
    }
  })

});
